<template>
    <div class="comment-replies__title">
        Комментарии ({{count}})
    </div>
</template>

<script>
    export default {
        name: "Header",
        computed: {
            count: function () {
                return this.$store.state.componentState.totalCount;
            }
        },
    }
</script>

<style scoped>

</style>
